import { render, staticRenderFns } from "./vip-city.vue?vue&type=template&id=230ae91c&scoped=true&"
import script from "./vip-city.vue?vue&type=script&lang=js&"
export * from "./vip-city.vue?vue&type=script&lang=js&"
import style0 from "./vip-city.vue?vue&type=style&index=0&lang=less&"
import style1 from "./vip-city.vue?vue&type=style&index=1&id=230ae91c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230ae91c",
  null
  
)

export default component.exports